import React, {useState} from "react";
import { Form, Row, Col, Typography, Button, Space, Checkbox, Switch } from 'antd';
import { CaretLeftOutlined } from '@ant-design/icons';
const { Title, Text } = Typography;
const CheckboxGroup = Checkbox.Group;
var defaults = [];
var initValues = {
    allergies: defaults
};
const AppStep21 = ({ next, prev, handleFormData, values }) => {
    const [switched, setSwitched] = useState(false);
    const [disabled, setDisabled] = useState(false);
    let vf = [];
    function onChange(checkedvalues) {
        return vf.push(checkedvalues);
    }
    const submitFormData = (e) => {
        if (switched === true) {
            values.allergies = JSON.stringify(defaults);
        }
        else if (switched === false){
            values.allergies = JSON.stringify(e.allergies);
        }
        onChange(e);
        next();
      }
      const onSwitch = (e) => {
        setSwitched(!switched);
        setDisabled(!disabled);
    }

    
    return(
        <Form 
            name="step21"
            onFinish={submitFormData}
            initialValues={initValues}
        >
            <Title level={2}>Avez-vous des restrictions alimentaires ou des allergies ?</Title>
            
            <Form.Item 
                name="allergies"
                defaultValue={values.allergies}
                onChange={handleFormData("allergies")}
                >
                    <CheckboxGroup
                        className="boxe"
                        style={{ width: '100%' }}
                        onChange={onChange}
                    >
                        <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Checkbox value="Je suis intolérant au lactose" disabled={disabled}><Text>Je suis intolérant au lactose</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Je ne mange pas de gluten" disabled={disabled}><Text>Je ne mange pas de gluten</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Je suis végétarien" disabled={disabled}><Text>Je suis végétarien</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Je suis végétalien" disabled={disabled}><Text>Je suis végétalien</Text></Checkbox>
                        </Col>
                        </Row>
                    </CheckboxGroup>
                </Form.Item>
                <Row justify="end">
                    <Col xs={{ span: 10 }} sm={{ span: 11 }} md={{ span: 11 }} lg={{ span: 9 }} xl={{ span: 7 }}>
                        <Text style={{lineHeight:2.3}} >Aucune de ces réponses </Text>
                    </Col>
                    <Col xs={{ span: 2 }} sm={{ span: 1 }}>
                        <Form.Item layout="inline" valuePropName="checked" name="firstSwitch">
                            <Switch checked={switched} onChange={onSwitch} />
                        </Form.Item>
                    </Col>
              </Row>
                <br />
        
            <Row justify="end">
            <Col xs={{ span: 8 }} sm={{ span: 6 }} md={{ span: 4 }}>
                <Form.Item  className="steps-action">
                <Space style={{ width: '100%' }}>
                    <Button onClick={prev} icon={<CaretLeftOutlined />} />
                    <Button type="primary" htmlType="submit">
                        Continue
                    </Button>
                </Space>
                </Form.Item>
            </Col>
            </Row>
        </Form>
    )
}
export default AppStep21;